import { render, staticRenderFns } from "./ScreenEvents.vue?vue&type=template&id=962af8ec&scoped=true"
import script from "./ScreenEvents.vue?vue&type=script&lang=js"
export * from "./ScreenEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962af8ec",
  null
  
)

export default component.exports